// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFontColorsOutlinedSvg from "@fishx/icons-svg/es/asn/PFontColorsOutlined";
import FishxIcon from '../components/FishxIcon';

var PFontColorsOutlined = function PFontColorsOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFontColorsOutlinedSvg
  }));
};

PFontColorsOutlined.displayName = 'PFontColorsOutlined';
export default React.forwardRef(PFontColorsOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFontColorsOutlined.js
// module id = 3421
// module chunks = 0